module.exports = __webpack_public_path__ + "static/media/cookieMarkerBrandRefreshSelected.21a101db.svg";